<template>
  <page status="approved" :title="i18n('Cadastros aprovados')" :description="i18n('cadastros aprovados')" />
</template>

<script>
import CustomersList from "./CustomersList"
export default {
  name: 'CustomersListApproved',
  components: { 'page': CustomersList },
  data() {
    return {}
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/CustomersListApproved.vue